module.exports = {

  default: { click: { dest: 'clientActivity', elem: 'page', act: 'show', id: `clientActivity-page`, leftnav: 'leftnav-clientActivity-page', from: 'leftnav' }, },

  //-------------------------------------------------------------------------------------------------------------------------------------
  clientActivity: {
    mainPage: true,
    activePage: '',
    click: { dest: 'clientActivity', elem: 'page', act: 'show', id: `clientActivity-page`, leftnav: 'leftnav-clientActivity-page', from: 'leftnav' },
  },

  clientPayments: {
    mainPage: true,
    activePage: '',
    click: { dest: 'clientPayments', elem: 'page', act: 'show', id: `clientPayments-page`, leftnav: 'leftnav-clientPayments-page', from: 'leftnav' },
  },

}